import React, { useState, useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { callSearchAgentInfo } from '../../../src/api/settings/service';
import { useTranslation } from "react-i18next";
const AgentCodeInput = ({ value = '', onSelect, initialData = null }) => {
	const dispatch = useDispatch();
	const [inputValue, setInputValue] = useState(value);
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);
	const containerRef = useRef(null);
	const debounceTimeout = useRef(null);
	const { t } = useTranslation();
	useEffect(() => {
		if (initialData) {
			setInputValue(`${initialData}`);
		}
	}, [initialData]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (containerRef.current && !containerRef.current.contains(event.target)) {
				setShowSuggestions(false);
			}
		};
		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleChange = async (e) => {
		const text = e.target.value;
		setInputValue(text);
		clearTimeout(debounceTimeout.current);
		if (text.length >= 2) {
			debounceTimeout.current = setTimeout(async () => {
				const response = await dispatch(callSearchAgentInfo({ keyword: text, page: 1, maxResult: 50 }));
				if (response?.payload?.responseCode === "00000") {
					setSuggestions(response.payload.data.result || []);
					setShowSuggestions(true);
				}
			}, 1000);

		} else {
			setSuggestions([]);
			setShowSuggestions(false);
		}
	};

	const handleSelect = (agent) => {
		console.log(agent)
		setInputValue(`${agent.agentCode} - ${agent.firstName} ${agent.lastName}`);
		setShowSuggestions(false);
		onSelect(agent);
	};

	return (
		<div ref={containerRef} style={{ position: 'relative' }}>
			<input
				type="text"
				className="form-control-uld"
				placeholder={t('callcenter.agent.searchByKey') + "..."}
				value={inputValue}
				onChange={handleChange}
				autoComplete="off"
			/>
			{showSuggestions && suggestions.length > 0 && (
				<ul style={{
					position: 'absolute',
					top: '100%',
					left: 0,
					right: 0,
					zIndex: 999,
					backgroundColor: '#fff',
					border: '1px solid #ccc',
					maxHeight: '200px',
					overflowY: 'auto',
					listStyle: 'none',
					margin: 0,
					padding: 0
				}}>
					{suggestions.map((agent, index) => (
						<li key={index} style={{ padding: '8px', cursor: 'pointer' }}
							onClick={() => handleSelect(agent)}>
							{agent.agentCode} - {agent.firstName} {agent.lastName}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default AgentCodeInput;
